var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48591 0 0 4.48591 0 10C0 15.5141 4.48591 20 10 20C15.5141 20 20 15.5141 20 10C20 4.48591 15.5141 0 10 0ZM10 18.5C5.69113 18.5 1.5 15.2632 1.5 10C1.5 5.5 4.73683 1.5 10 1.5C15.2632 1.5 18.5 5.19113 18.5 10C18.5 14.5 14.3089 18.5 10 18.5Z",
    fill: "#727E8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8656 10.0121V5.82084C10.8656 5.35286 10.4864 4.97363 10.0186 4.97363C9.55064 4.97363 9.17137 5.35286 9.17137 5.82084V10.2827C9.17137 10.296 9.17466 10.3085 9.1753 10.3219C9.16416 10.5522 9.24352 10.7861 9.41945 10.9621L12.5747 14.1171C12.9056 14.448 13.442 14.448 13.7727 14.1171C14.1034 13.7861 14.1036 13.2498 13.7727 12.919L10.8656 10.0121Z",
    fill: "#727E8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.c6a83b57.svg";
export { ForwardRef as ReactComponent };